SelectClubService = ($http) ->
  getClubs: (keyword, pageParams) ->
    url = "/api/clubs/search.json"
    params =
     page: pageParams.page
     keyword: keyword

    $http.get(url, params: params)

  getPlayedClubs: (pageParams) ->
    url = "/api/clubs/played.json"
    params =
      page: pageParams.page

    $http.get(url, params: params)
  
SelectClubService.$inject = [
  '$http'
]

module.exports = SelectClubService


// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/score-registration/select-club/select-club-service.coffee